import { VenueShowType as ApiVenueShowType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { VenueShowType } from './types';

export const mapVenueShowType = (
  apiVenueShow: ApiVenueShowType
): VenueShowType => {
  return {
    id: apiVenueShow.id,
    date: apiVenueShow.date,
    artist: mapLinkableEntityType(apiVenueShow.artist),
    tour: apiVenueShow.tour ? mapLinkableEntityType(apiVenueShow.tour) : null,
    status: apiVenueShow.status,
    production: apiVenueShow.production ?? null,
    showSetup: apiVenueShow.showSetup ?? null,
    configuration: apiVenueShow.configuration,
    rentalAgreementUrl: apiVenueShow.rentalAgreementUrl ?? null,
  };
};
